module.exports = __webpack_public_path__ + "img/in.51112aca.svg";